import { NS_SVG } from "../constants";
import { SVG_GetDefs } from "./SVG_GetDefs";

export function SVG_AddDefs(svgElement) {
  var filter = document.createElementNS(NS_SVG, "filter");
  filter.setAttribute("id", "f1");
  filter.setAttribute("x", "-20%");
  filter.setAttribute("y", "-20%");
  filter.setAttribute("width", "150%");
  filter.setAttribute("height", "150%");

  var feOffset = document.createElementNS(NS_SVG, "feOffset");
  feOffset.setAttribute("result", "offOut");
  feOffset.setAttribute("in", "SourceAlpha");
  feOffset.setAttribute("dx", "3");
  feOffset.setAttribute("dy", "3");
  filter.appendChild(feOffset);

  var feGaussianBlur = document.createElementNS(NS_SVG, "feGaussianBlur");
  feGaussianBlur.setAttribute("result", "blurOutDark");
  feGaussianBlur.setAttribute("in", "offOut");
  feGaussianBlur.setAttribute("stdDeviation", "0.3");
  filter.appendChild(feGaussianBlur);

  var feColorMatrix = document.createElementNS(NS_SVG, "feColorMatrix");
  feColorMatrix.setAttribute("result", "blurOut");
  feColorMatrix.setAttribute("in", "blurOutDark");
  feColorMatrix.setAttribute("type", "matrix");
  feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.098 0");
  filter.appendChild(feColorMatrix);

  var feComposite = document.createElementNS(NS_SVG, "feComposite");
  feComposite.setAttribute("in", "SourceGraphic");
  feComposite.setAttribute("in2", "blurOut");
  feComposite.setAttribute("operator", "over");
  filter.appendChild(feComposite);

  var defs = SVG_GetDefs(svgElement); //document.createElementNS(NS_SVG, "defs");
  defs.appendChild(filter);
  //svgElement.appendChild(defs);
}
